import { z } from 'zod';
/** The chat, truck and driver panels (core/domain/artifact-people.ts). */
export const chatArtifactSchema = z.object({
    kind: z.literal('chat'),
    title: z.string().optional(),
    /** Oldest first: the newest message is last. */
    messages: z.array(z.object({
        sender: z.string().optional(),
        at: z.string(),
        text: z.string().optional(),
    })),
    truncated: z.boolean(),
});
const vehicleLineSchema = z.object({
    unit: z.string(),
    vin: z.string().optional(),
    make: z.string().optional(),
    model: z.string().optional(),
    year: z.string().optional(),
    plate: z.string().optional(),
    status: z.string().optional(),
    /** Shown when the row opens: whatever else the record carried, as label/value. */
    details: z.array(z.object({ label: z.string(), value: z.string() })).optional(),
});
export const vehicleArtifactSchema = z.object({
    kind: z.literal('vehicle'),
    vehicles: z.array(vehicleLineSchema),
    truncated: z.boolean(),
});
export const driverArtifactSchema = z.object({
    kind: z.literal('driver'),
    drivers: z.array(z.object({
        name: z.string(),
        status: z.string().optional(),
        phone: z.string().optional(),
        email: z.string().optional(),
        assignedTruck: z.string().optional(),
    })),
    truncated: z.boolean(),
});
//# sourceMappingURL=artifacts-people.js.map